/**
 * Flatten a nested route structure into a dictionary.
 * Each route's name is used as the key and its href as the value.
 * Nested routes are also included in the dictionary.
 * @param {Array} routes - The nested route structure.
 * @return {Object} - A dictionary with route names as keys and hrefs as values.
 */
export default function flattenRoutesToDict(routes) {
  const dict = {};

  function recurse(routeList) {
    for (const route of routeList) {
      if (route.name && route.href) {
        dict[route.name] = route.href;
      }
      if (route.routes) {
        recurse(route.routes);
      }
    }
  }

  recurse(routes);
  return dict;
}
